import { render, staticRenderFns } from "./ChildProtectionPolicy.vue?vue&type=template&id=35a287fc&scoped=true"
import script from "./ChildProtectionPolicy.vue?vue&type=script&lang=js"
export * from "./ChildProtectionPolicy.vue?vue&type=script&lang=js"
import style0 from "./ChildProtectionPolicy.vue?vue&type=style&index=0&id=35a287fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a287fc",
  null
  
)

export default component.exports